import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DropFile.scss';
import Dropzone from 'react-dropzone';

class DropFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      fileList: null,
      isFileSelected: false,
    };
  }

  handleOnDrop = (acceptedFiles) => {
    let fileNames = ''
    for (let i = 0; i < acceptedFiles.length; i++) {
      fileNames += acceptedFiles[i].name + ', ';
    }

    this.setState({
      fileName: this.props.multiple ? fileNames : acceptedFiles[0].name.replace(/^.*[\\\/]/, ''),
      fileList: this.props.multiple ? acceptedFiles : acceptedFiles[0],
    }, () => {
      let isFileSelected = false;
      (this.state.fileList) ? isFileSelected = true : isFileSelected = false;
      this.setState({ isFileSelected }, () => this.props.onFileSelect(this.state));
    });
  }

  componentWillReceiveProps() {
    if (this.props.shouldReset) {
      this.resetComponent();
    }
  }

  resetComponent = () => {
    this.setState({
      fileName: '',
      fileList: null,
      isFileSelected: false,
    });
  }

  render() {
    const labelType = this.props.labelType;
    return (
      <Dropzone
        accept={this.props.accept}
        labelType={this.props.labelType}
        multiple={this.props.multiple}
        onDrop={this.handleOnDrop.bind(this)}
      >
        {
          ({ getRootProps, getInputProps }) => {
            return (
              <div {...getRootProps()} className="drop-zone">
                <input {...getInputProps()} />
                <i className="glyphicon glyphicon-folder-open" />&nbsp;&nbsp;
                Kliknij albo przeciągnij plik tutaj...
                <span className={`fileNameLabel label-${labelType}`} >
                  {this.state.fileName}
                </span>
              </div>
            );
          }
        }
      </Dropzone>
    );
  }
}

export default withStyles(s)(DropFile);


// WEBPACK FOOTER //
// src/components/DropFile/DropFile.js